export default __webpack_public_path__ + "static/media/dashboard.b18d306d.png";